<template>
    <div>
      <section class="hero has-background-grey-lighter is-fullheight">
        <div class="content">
            <br><br><br><br><br>
            <div class="container has-text-centered ">
                <slot name="contenido"></slot>
              
            </div>
        </div>
    </section>
    </div>

</template>
<script>
export default {
    name: 'PlantillaLogin'
}
</script>
<style scoped>
html,body {
  font-family: 'Questrial', sans-serif;
  font-size: 14px;
  font-weight: 300;
}
.hero.is-success {
  background: #F2F6FA;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
  box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr{
  border-bottom: 1px solid black;
}

.has-text-black{
  color: black;
}

.field{
  padding-bottom: 10px;
}

.fa{
  margin-left: 5px; 
}
</style>

<style lang="scss">
  @import "~bulma/sass/utilities/_all";
 $my-primary: #0B5B67;
  $link: #0B5B67;
  $primary-invert: white;
  $colors: (
    "primary": ($my-primary, $primary-invert),
    "pagination-focus-border-color":(#0B5B67, black),
   
  );
  // Import Bulma and Buefy styles
  @import "~bulma"; 
  @import "~buefy/src/scss/buefy";

</style>
